import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18n"; // Initialize i18n

// CRITICAL: Handle OAuth callback BEFORE React renders
// This runs synchronously before any React code
(function handleOAuthCallback() {
  const hash = window.location.hash;
  
  // Check if this is an OAuth callback with session_id
  if (hash && hash.includes('session_id=')) {
    const sessionIdMatch = hash.match(/session_id=([^&]+)/);
    if (sessionIdMatch) {
      const sessionId = sessionIdMatch[1];
      console.log('[OAuth] Detected callback with session_id:', sessionId);
      
      // Show loading indicator immediately
      document.body.innerHTML = `
        <div style="display: flex; align-items: center; justify-content: center; min-height: 100vh; background: black;">
          <div style="text-align: center;">
            <div style="width: 48px; height: 48px; border: 3px solid #333; border-top-color: #eab308; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto 16px;"></div>
            <p style="color: #9ca3af;">Completing sign in...</p>
          </div>
        </div>
        <style>@keyframes spin { to { transform: rotate(360deg); } }</style>
      `;
      
      // Get backend URL
      const hostname = window.location.hostname;
      let backendUrl = '';
      if (hostname === 'prospermind.com') {
        backendUrl = 'https://prospermind.com';
      } else if (hostname.includes('emergent')) {
        backendUrl = `https://${hostname}`;
      }
      
      // Exchange session_id for token
      fetch(`${backendUrl}/api/auth/session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ session_id: sessionId }),
      })
      .then(response => {
        console.log('[OAuth] Session exchange status:', response.status);
        if (!response.ok) throw new Error('Session exchange failed');
        return response.json();
      })
      .then(data => {
        console.log('[OAuth] Session exchange SUCCESS');
        
        // Store auth data
        const userData = {
          id: data.user_id,
          name: data.name || data.email?.split('@')[0],
          email: data.email,
          picture: data.picture,
          subscription_plan: data.subscription_tier || 'free',
          auth_type: 'oauth'
        };
        
        sessionStorage.setItem('prosperMindAuth', 'true');
        sessionStorage.setItem('prosperMindUser', JSON.stringify(userData));
        sessionStorage.setItem('prosperMindToken', data.session_token);
        sessionStorage.setItem('authToken', data.session_token);
        sessionStorage.setItem('session_token', data.session_token);
        
        // Redirect to dashboard
        console.log('[OAuth] Redirecting to /dashboard');
        window.location.replace('/dashboard');
      })
      .catch(error => {
        console.error('[OAuth] Error:', error);
        // Clean up and let React handle it
        window.history.replaceState({}, document.title, '/');
        window.location.reload();
      });
      
      // Stop React from rendering while we handle OAuth
      return;
    }
  }
  
  // No OAuth callback - render React app normally
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
})();

